
















































































































import QrLogo from 'qrcode-with-logos'
import Vue from 'vue'
import {
  Component,
  VModel,
  Prop,
  Watch,
} from 'vue-property-decorator'

import {
  errorNotificationWrapper,
  successNotificationWrapper,
  warningNotificationWrapper
} from '../../logic/helpers/NotificationService'
import MiniHelpMessage from '../MiniHelpMessage/MiniHelpMessage.vue'

@Component({
  components: {
    MiniHelpMessage,
  }
})
export default class FlowsListLink extends Vue {
  @VModel() isOpen!: boolean

  @Prop() flow!: { key: string, title: string, link: string } | null

  @Prop() avatar!: string

  @Prop() createUtm!: (utm: string, key: string) => Promise<string>

  @Watch('isOpen')
  isOpenWatcher(val: boolean): void {
    if (!val) {
      this.utm = {
        name: '',
        link: '',
      }
    } else {
      this.$nextTick(() => {
        if (this.flow) {
          const img = document.getElementById('flow-qr') as HTMLImageElement

          if (img) {
            let qrCode = new QrLogo({
              content: this.flow.link,
              width: 200,
              image: img,
              logo: {
                src: this.avatar,
                logoSize: 0.25,
                borderSize: 0.03,
                borderRadius: 50,
              }
            })

            this.qrCode = qrCode
            qrCode.toImage()
          }
        }
      })
    }
  }

  qrCode: QrLogo | null = null

  utm = {
    name: '',
    link: '',
  }

  download(): void {
    if (this.qrCode) {
      this.qrCode.downloadImage('qrcode')
    }
  }

  copyText(text: string): void {
    try {
      // eslint-disable-next-line compat/compat
      navigator.clipboard.writeText(text)
      successNotificationWrapper(this.$t('success').toString(), this.$t('copy_link_to_buffer').toString())
    } catch (error) {
      errorNotificationWrapper(this.$t('error').toString(), error as string)
    }
  }

  createUTM(flow_key: string): void {
    if (this.utm.name.trim()) {
      if (!this.utm.link) {
        this.createUtm(this.utm.name, flow_key).then((link) => this.utm.link = link)
      } else {
        this.utm = {
          name: '',
          link: ''
        }
      }
    } else {
      warningNotificationWrapper(this.$t('warning').toString(), this.$t('flows_list_name_placeholder').toString())
    }
  }
}
